import React from 'react';
import ImageGalleryalkitab from '../components/ImageGalleryalkitab';
import DonationDetailsAlkitabsection from "./DonationDetailsAlkitabsection";


const IRCALKITAB = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryalkitab />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>AL KITAB EDUCATION & WELFARE SOCIETY</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                Al Kitab Education & Welfare Society, founded by Adv. Faiz Syed, is a welfare organization dedicated to serving communities through initiatives in education, healthcare support, employment guidance, and poverty alleviation. The society works to uplift underprivileged individuals by providing access to essential resources, promoting self-reliance, and creating opportunities for a better and more dignified life. Al Kitab runs a full time Study Centre at Sultan Complex, Shop No.5, Near Shalimar Kitab Ghar, Roshan Gate, Chhatrapati Sambhajinagar (Aurangabad).


                            </p>
                        </div>
                        <DonationDetailsAlkitabsection
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCALKITAB;
